import { call, put, takeEvery } from "redux-saga/effects";

import {
  INFORMES_LISTA,
  INFORMES_LIST,
  INFORMES_FILTER,
  INFORMES_CREATE,
  INFORMES_UPDATE,
  INFORMES_READ
} from "./actionTypes";

import {
  
  informesListSuccess,
  informesCreateSuccess,
  informesUpdateSuccess,
  informesRequestFailed,
 
} from "./actions";

import {
  getInformesList,
  getInformesFullList,
  getInformesFilter,
  getInformesRead,
  postInformesCreate,
  patchInformesUpdate,

} from "../../helpers/backend";



function*informesListSaga() {
  console.log("Trayendo lista de informes...");
  try {
    const response = yield call(getInformesList);
    if (response.status === 200) {
      yield put(informesListSuccess(response.data));
    } else {
      yield put(informesRequestFailed(response.data));
    }
  } catch (error) {
    yield put(informesRequestFailed(error.response.data));
  }
}

function*informesListaSaga() {
  console.log("Trayendo lista de informes...");
  try {
    const response = yield call(getInformesFullList);
    if (response.status === 200) {
      yield put(informesListSuccess(response.data));
    } else {
      yield put(informesRequestFailed(response.data));
    }
  } catch (error) {
    yield put(informesRequestFailed(error.response.data));
  }
}

function*informesCreateSaga({ payload:informes }) {
  console.log("Creando nuevo informes...");
  try {
    const response = yield call(postInformesCreate,informes);
    if (response.status === 201) {
      yield put(informesCreateSuccess(response.data));
    } else {
      yield put(informesRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(informesRequestFailed(error.response.data));
  }
}

function*informesFilterSaga({ payload: { changeUrl } }) {
  console.log("Trayendo informe filtrado")
  try {
    const response = yield call(getInformesFilter, { changeUrl });
    if (response.status === 200) {
      yield put(informesListSuccess(response.data));
     
    } else {
      yield put(informesRequestFailed(response.data));
      
    }
  } catch (error) {
    yield put(informesRequestFailed(error.response.data));
  }
}

function*informesUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando datos de la herramienta...");
  try {
    const response = yield call(patchInformesUpdate, { id }, data);
    if (response.status === 200) {
      yield put(informesUpdateSuccess(response.data));
    } else {
      yield put(informesRequestFailed(response.data));
      console.log(response.data)
    }
  } catch (error) {
    yield put(informesRequestFailed(error.response.data));
  }
}

function*informesReadSaga({ payload: { id, data } }) {
  console.log("Trayendo el read.");
  try {
    const response = yield call(getInformesRead, { id });
    if (response.status === 200) {
      yield put(informesListSuccess(response.data));
    } else {
      yield put(informesRequestFailed(response.data));
    }
  } catch (error) {
    yield put(informesRequestFailed(error.response.data));
  }
}

export default function*informesSaga() {
  yield takeEvery(INFORMES_LIST,informesListSaga);
  yield takeEvery(INFORMES_LISTA,informesListaSaga);
  yield takeEvery(INFORMES_FILTER,informesFilterSaga);
  yield takeEvery(INFORMES_CREATE,informesCreateSaga);
  yield takeEvery(INFORMES_UPDATE,informesUpdateSaga);
  yield takeEvery(INFORMES_READ,informesReadSaga);
}
